import React from 'react';

interface StartButtonProps {
  callback: () => void;
  paused: boolean;
}

const StartButton: React.FC<StartButtonProps> = ({ callback, paused }) => (
  <button className="start-button" onClick={callback}>
    {paused ? 'Resume Game' : 'Start Game'}
  </button>
);

export default StartButton;